/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Col,
  Tab,
  Tabs,
  Popover,
  Row,
  OverlayTrigger,
  Table,
  CloseButton,
} from "react-bootstrap";
import { Spinner } from "react-bootstrap";
import {
  DANGER,
  EMPTY,
  INFO,
  LOGERROR,
  SHOW_BUSINESS,
  SHOW_FARM,
  SHOW_FIELD,
} from "../../configurations/Constants";
import Alert from "../common/Alert";
import FluentdHelper from "../../helpers/FluentdHelper";
import ShareFieldService from "../../api-service/ShareFieldService";
import SessionHelper from "../../helpers/SessionHelper";
import TabSharedFieldDetails from "../fieldDetails/TabSharedFieldDetails";
import TabCropDetails from "../fieldDetails/TabCropDetails";
import TabSummary from "../fieldDetails/TabSummary";
import TabReport from "../fieldDetails/TabReport";
import { useSelector, useDispatch } from "react-redux";
import {
  setInitialFarms,
  setInitialBusiness,
} from "../../configurations/redux-configurations/actions/fieldAction";

import {
  FIELD_FARM_BUSINESS_CANNOT_BE_EMPTY,
  SHARED_FIELD_UPDATED_SUCCESSFULLY,
  ONE_WELL_SHOULD_BE_ACTIVE,
  DATA_UPDATED_SUCCESSFULLY,
  ERROR_WHILE_UPDATING_FIELD,
  SELECT_FARM,
  ENTER_VALUE,
  INVALID_VALUE,
  FARM_NAME_EXIST,
  ENTER_FARM_NAME,
  SELECT_BUSINESS,
  ENTER_BUSINESS_NAME,
  BUSINESS_NAME_EXIST,
} from "../../configurations/MessageConstants";
import TabNotes from "../fieldDetails/TabNotes";
import UserService from "../../api-service/UserService";
import FieldWellDetails from "./FieldWellDetails";
import LoadingOverlay from "../common/LoadingOverlay";
import { StatusCodes } from "../../configurations/status-codes";

function FarmerFieldDetails(props) {
  const dispatch = useDispatch();
  const loggedInUser = useSelector((state) => state.user.loggedInUser);
  const FarmsValue = useSelector((state) => state.field.farms);
  const BusinessValue = useSelector((state) => state.field.business);

  const [validated, setValidated] = useState(false);
  const [fieldName, setFieldName] = useState(EMPTY);
  const [farmName, setFarmName] = useState(EMPTY);
  const [businessName, setBusinessName] = useState(EMPTY);
  const [acres, setAcres] = useState(EMPTY);
  const [isWellShown, setIsWellShown] = useState(false);
  const [surfaceWaterIrrigation, setSurfaceWaterIrrigation] = useState(false);
  const [well_details, setWell_details] = useState({});
  const [surfaceWaterPercentage, setSurfaceWaterPercentage] = useState(0);
  const [groundWaterPercentage, setGroundWaterPercentage] = useState(0);
  const [display_form, setDisplay_form] = useState(SHOW_FIELD);
  const [farmValidated, setFarmValidated] = useState(false);
  const [businessValidated, setBusinessValidated] = useState(false);
  const [newBusinessName, setNewBusinessName] = useState(EMPTY);
  const [newFarmName, setNewFarmName] = useState(EMPTY);
  const [btnAddFarmClick, setBtnAddFarmClick] = useState(false);
  const [fieldNameError, setFieldNameError] = useState(false);
  const [btnAddBusinessClick, setBtnAddBusinessClick] = useState(false);
  const [farms, setFarms] = useState(FarmsValue);
  const [fieldError, setFieldError] = useState(false);
  const [farmError, setFarmError] = useState(false);
  const [businessError, setBusinessError] = useState(false);
  const [fieldAlertMessage, setFieldAlertMessage] = useState(EMPTY);
  const [fieldVariant, setFieldVariant] = useState(DANGER);
  const [regFieldIrrigUnitId, setRegFieldIrrigUnitId] = useState(EMPTY);
  const [regFieldGuid, setRegFieldGuid] = useState(EMPTY);
  const [regFieldId, setRegFieldId] = useState(EMPTY);
  const [dataFetched, setDataFetched] = useState(false);
  const [invalidFarmNameError, setInvalidFarmNameError] = useState(false);
  const [invalidBusinessNameError, setInvalidBusinessNameError] =
    useState(false);
  const [btnAddFieldClick, setBtnAddFieldClick] = useState(false);

  useEffect(() => {
    const fieldDetailsValue = props.fieldDetails;
    let wells = [];
    let fieldNameValue = EMPTY;
    let farmNameValue = EMPTY;
    let businessNameValue = EMPTY;
    let acresValue = EMPTY;
    let surfaceGroundPercetageValue = false;
    if (fieldDetailsValue) {
      if (props.sharedField === true) {
        fieldNameValue = props.shareFieldDetails.field_name;
        farmNameValue = props.shareFieldDetails.farm_name;
        businessNameValue = props.shareFieldDetails.business_name;
        acresValue = parseFloat(props.shareFieldDetails.acres).toFixed(2);
      } else {
        fieldNameValue = fieldDetailsValue.field_name;
        farmNameValue = fieldDetailsValue.farm_name;
        businessNameValue = fieldDetailsValue.business_name;
        acresValue = parseFloat(fieldDetailsValue.acres).toFixed(2);
      }

      wells = fieldDetailsValue.well_data.map((well) => ({
        id: well.id,
        well_id: well.well_id,
        gpm: well.pump_rate,
        ugpm: well.updated_pump_rate,
        activeWell: well.is_active,
        isElectricWell: well.is_electric,
        audited_gpm: well.audited_pump_rate ? well.audited_pump_rate : "N/A",
      }));

      surfaceGroundPercetageValue =
        fieldDetailsValue.ground_water_percent !== 0 ||
        fieldDetailsValue.surface_water_percent !== 0
          ? true
          : false;
    }
    setFieldName(fieldNameValue);
    setFarmName(farmNameValue);
    setBusinessName(businessNameValue);
    setAcres(acresValue);
    setSurfaceWaterIrrigation(surfaceGroundPercetageValue);
    setSurfaceWaterPercentage(fieldDetailsValue.surface_water_percent);
    setGroundWaterPercentage(fieldDetailsValue.ground_water_percent);
    setWell_details(wells);
    setIsWellShown(true);
    setRegFieldIrrigUnitId(fieldDetailsValue.irrig_unit_id);
    setRegFieldId(
      fieldDetailsValue.user_field_id
        ? fieldDetailsValue.user_field_id
        : fieldDetailsValue.field_id
    );
    setRegFieldGuid(fieldDetailsValue.guid);
    setDataFetched(true);
  }, []);

  const onChange = (e) => {
    if (e.target.name === "fieldName") setFieldName(e.target.value);
    else if (e.target.name === "newFarmName") setNewFarmName(e.target.value);
    else if (e.target.name === "newBusinessName")
      setNewBusinessName(e.target.value);
  };

  const closeModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    props.closeModal();
  };

  const closeFieldDetailsAlert = () => {
    setFieldError(false);
    setFarmError(false);
    setBusinessError(false);
    setFieldAlertMessage(EMPTY);
    setFieldVariant(DANGER);
  };
  const updateWellDetails = (updatedWellData, idx) => {
    let newwell_details = well_details.map((well, sidx) => {
      if (idx !== sidx) return well;
      return updatedWellData;
    });
    setWell_details(newwell_details);
  };

  const handle_farm_change = (e) => {
    setFarmName(e.target.value);
  };
  const add_new_farm = () => {
    setDisplay_form(SHOW_FARM);
    setFarmName(EMPTY);
    setBusinessName(EMPTY);
  };

  const handle_business_change = (e) => {
    setBusinessName(e.target.value);
  };
  const add_new_business = () => {
    setDisplay_form(SHOW_BUSINESS);
    setBusinessName(EMPTY);
  };

  const onCheckboxChecked = (e) => {
    setSurfaceWaterIrrigation(!surfaceWaterIrrigation);
    setGroundWaterPercentage(EMPTY);
    setSurfaceWaterPercentage(EMPTY);
  };

  const surfaceWaterChange = (e) => {
    let surfaceWaterPercentageValue = e.target.value;
    if (e.target.value > 100) {
      surfaceWaterPercentageValue = 100;
    }
    setSurfaceWaterPercentage(surfaceWaterPercentageValue);
    setGroundWaterPercentage(100 - surfaceWaterPercentageValue);
  };

  const groundWaterChange = (e) => {
    let groundWaterPercentageValue = e.target.value;
    if (e.target.value > 100) {
      groundWaterPercentageValue = 100;
    }
    setGroundWaterPercentage(groundWaterPercentageValue);
    setSurfaceWaterPercentage(100 - groundWaterPercentageValue);
  };

  const hideShowPopup = (event) => {
    event.preventDefault();
    if (display_form === SHOW_BUSINESS) {
      setDisplay_form(SHOW_FARM);
      setNewBusinessName(EMPTY);
      setBusinessValidated(false);
      setFarmValidated(false);
    } else if (display_form === SHOW_FARM) {
      setNewFarmName(EMPTY);
      setBusinessName(EMPTY);
      setDisplay_form(SHOW_FIELD);
      setBusinessValidated(false);
      setFarmValidated(false);
    }
  };

  const handle_add_farm = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setBtnAddFarmClick(true);
    const farmsValue = farms;
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setFarmValidated(true);
      setBtnAddFarmClick(false);
      return false;
    } else {
      if (newFarmName.trim() === EMPTY) {
        setFarmValidated(true);
        setBtnAddFarmClick(false);
        setFarmError(true);
        return false;
      }
      for (let i = 0; i < farmsValue.length; i++) {
        if (
          newFarmName.trim().toLowerCase() ===
          farmsValue[i].farmName.trim().toLowerCase()
        ) {
          setFarmValidated(true);
          setInvalidFarmNameError(true);
          setBtnAddFarmClick(false);
          return false;
        }
      }
    }

    farmsValue.push({
      farmName: newFarmName,
      businessName: businessName,
    });
    const newFarmNameValue = newFarmName;
    dispatch(setInitialFarms(farmsValue));

    setDisplay_form(SHOW_FIELD);
    setFarms(farmsValue);
    setNewFarmName(EMPTY);
    setBusinessName(EMPTY);
    setFarmName(newFarmNameValue);
    setInvalidFarmNameError(false);
    setBtnAddFarmClick(false);
  };

  const handle_add_business = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setBtnAddBusinessClick(true);
    const businessProps = BusinessValue;
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setBusinessValidated(true);
      setBtnAddBusinessClick(false);
      return false;
    } else {
      if (newBusinessName.trim() === EMPTY) {
        setBusinessValidated(true);
        setBtnAddBusinessClick(false);
        setBusinessError(true);
        return false;
      }

      for (let i = 0; i < businessProps.length; i++) {
        if (
          newBusinessName.trim().toLowerCase() ===
          businessProps[i].trim().toLowerCase()
        ) {
          setFarmValidated(true);
          setInvalidBusinessNameError(true);
          setBtnAddBusinessClick(false);
          return false;
        }
      }
    }

    const newBusinessNameValue = newBusinessName;
    businessProps.push(newBusinessName);

    setDisplay_form(SHOW_FARM);
    setNewBusinessName(EMPTY);
    setBusinessName(newBusinessNameValue);
    setInvalidBusinessNameError(false);
    setBtnAddBusinessClick(false);
    dispatch(setInitialBusiness(businessProps));
  };

  const handleSharedFieldUpdate = async (event) => {
    event.persist();
    event.preventDefault();
    event.stopPropagation();
    await SessionHelper.handleRefreshToken();

    setBtnAddFieldClick(true);
    setFieldNameError(false);

    const farmsValue = farms;
    let fieldNameValue = fieldName;
    let farmNameValue = farmName;
    let businessNameValue = businessName;

    for (let i = 0; i < farmsValue.length; i++) {
      if (farmsValue[i].farmName.trim() === farmNameValue.trim()) {
        businessNameValue = farmsValue[i].businessName;
        break;
      }
    }
    if (
      businessNameValue.trim() === EMPTY ||
      farmNameValue.trim() === EMPTY ||
      fieldNameValue.trim() === EMPTY
    ) {
      setBtnAddFieldClick(false);
      setFieldError(true);
      setFieldAlertMessage(FIELD_FARM_BUSINESS_CANNOT_BE_EMPTY);
      return false;
    } else {
      setFieldError(false);
      setFieldAlertMessage(EMPTY);
    }
    const form = event.target.form;
    if (form.checkValidity() === false) {
      setValidated(true);
      setBtnAddFieldClick(false);
      return false;
    } else {
      let userSharedFields = props.userSharedFields;
      if (userSharedFields && userSharedFields.length > 0) {
        for (let i = 0; i < userSharedFields.length; i++) {
          if (
            userSharedFields[i].field_name.trim().toLowerCase() ===
              fieldNameValue.trim().toLowerCase() &&
            regFieldIrrigUnitId !== userSharedFields[i].irrig_unit_id
          ) {
            setValidated(true);
            setBtnAddFieldClick(false);
            setFieldNameError(true);
            return false;
          }
        }
      }
      updateSharedFieldDetails(
        fieldNameValue,
        farmNameValue,
        businessNameValue,
        props.shareFieldDetails.shared_field_id
      );
    }
  };

  const updateSharedFieldDetails = async (
    fieldName,
    farmName,
    businessName,
    sharedFieldId
  ) => {
    const user_email = loggedInUser;
    const payload = {
      shared_field_id: sharedFieldId,
      business_name: businessName,
      farm_name: farmName,
      field_name: fieldName,
    };
    try {
      await ShareFieldService.updateShareFieldDetails(payload);
      await props.refreshPanel(false);

      setFieldError(true);
      setFieldVariant(INFO);
      setBtnAddFieldClick(false);
      setFieldAlertMessage(SHARED_FIELD_UPDATED_SUCCESSFULLY);
    } catch (error) {
      let responseData = error.response.data;
      if (error.response.status === StatusCodes.BAD_REQUEST) {
        setBtnAddFieldClick(false);
        setFieldError(true);
        setFieldVariant(DANGER);
        setFieldAlertMessage(responseData.message);
      }
      handleFieldErrorAlert();
      FluentdHelper.logEvent(
        ERROR_WHILE_UPDATING_FIELD,
        "fieldDetails_updateSharedFieldDetails",
        user_email,
        {
          request: payload,
          response: error,
        },
        LOGERROR
      );
    }
  };

  const handleOnsubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    await SessionHelper.handleRefreshToken();

    setBtnAddFieldClick(true);
    setFieldNameError(false);

    let businessNameValue = businessName;
    let fieldNameValue = fieldName;
    let farmNameValue = farmName;
    let farmsValue = farms;

    for (let i = 0; i < farmsValue.length; i++) {
      if (farmsValue[i].farmName.trim() === farmNameValue.trim()) {
        businessNameValue = farmsValue[i].businessName;
        break;
      }
    }
    if (
      businessNameValue.trim() === EMPTY ||
      farmNameValue.trim() === EMPTY ||
      fieldNameValue.trim() === EMPTY
    ) {
      setBtnAddFieldClick(false);
      setFieldError(true);
      setFieldAlertMessage(FIELD_FARM_BUSINESS_CANNOT_BE_EMPTY);
      return false;
    } else {
      setFieldError(false);
      setFieldAlertMessage(EMPTY);
    }

    const form = event.target;
    if (form.checkValidity() === false) {
      setValidated(true);
      setBtnAddFieldClick(false);
      return false;
    } else {
      if (props.fieldNames && props.fieldNames.length > 0) {
        for (let i = 0; i < props.fieldNames.length; i++) {
          if (
            props.fieldNames[i].fieldName ===
              fieldNameValue.trim().toLowerCase() &&
            regFieldIrrigUnitId !== props.fieldNames[i].irrig_unit_id &&
            props.fieldNames[i].isShared === false
          ) {
            setValidated(true);
            setBtnAddFieldClick(false);
            setFieldNameError(true);
            return false;
          }
        }
      }

      const activeWellCount = well_details.filter((well) => {
        if (well.activeWell === true) {
          return well;
        }
      });
      if (activeWellCount.length === 0) {
        setValidated(true);
        setBtnAddFieldClick(false);
        setFieldError(true);
        setFieldAlertMessage(ONE_WELL_SHOULD_BE_ACTIVE);
        return false;
      }
      updateRegisteredFieldPopUpData(
        fieldNameValue,
        farmNameValue,
        businessNameValue,
        surfaceWaterIrrigation,
        well_details,
        surfaceWaterPercentage,
        groundWaterPercentage,
        regFieldGuid,
        regFieldId,
        regFieldIrrigUnitId
      );
    }
  };

  const updateRegisteredFieldPopUpData = async (
    fieldName,
    farmName,
    businessName,
    surfaceWaterIrrigation,
    well_details,
    surfaceWaterPercentage,
    groundWaterPercentage,
    regFieldGuid,
    regFieldId,
    regFieldIrrigUnitId
  ) => {
    const wells = [];
    for (let i = 0; i < well_details.length; i++) {
      const well = well_details[i];
      let updatedgpm = well.ugpm;
      if (well.ugpm === EMPTY) {
        updatedgpm = well.gpm;
      }
      wells.push({
        wellid: well.id,
        well_id: well.well_id,
        pump_rate: well.gpm,
        updated_pump_rate: parseInt(updatedgpm),
        active: well.activeWell,
        isElectricWell: well.isElectricWell,
      });
    }

    try {
      const payload = {
        field_id: regFieldId,
        field_name: fieldName,
        business_name: businessName,
        farm_name: farmName,
        well_data: wells,
        groundWaterPercentage: parseInt(groundWaterPercentage) || 0,
        surfaceWaterPercentage: parseInt(surfaceWaterPercentage) || 0,
      };

      await UserService.updateRegisteredField(payload);
      await props.refreshPanel(false);
      setFieldError(true);
      setFieldVariant(INFO);
      setBtnAddFieldClick(false);
      setFieldAlertMessage(DATA_UPDATED_SUCCESSFULLY);
    } catch (error) {
      let responseData = error.response.data;
      if (error.response.status === StatusCodes.BAD_REQUEST) {
        setFieldError(true);
        setFieldVariant(DANGER);
        setBtnAddFieldClick(false);
        setFieldAlertMessage(responseData.message);
      } else handleFieldErrorAlert();
    }
  };

  const handleFieldErrorAlert = () => {
    setBtnAddFieldClick(false);
    setFieldError(true);
    setFieldAlertMessage(ERROR_WHILE_UPDATING_FIELD);
  };

  const DisplayNotesTab = () => {
    if (SessionHelper.isStaffMember()) {
      return (
        <Tab eventKey="notes" title="Notes">
          <TabNotes
            handleCloseModel={(e) => closeModal(e)}
            fieldDetails={props.fieldDetails}
          ></TabNotes>
        </Tab>
      );
    }
  };

  let closeFieldModal = () => {};
  let farm_list = [];
  let business_list = [];
  let i = 0;
  let businessProps = BusinessValue;
  let farmsProps = FarmsValue;
  let parser = new DOMParser();

  for (i = 0; i < farmsProps.length; i++) {
    const farmNameDoc = parser.parseFromString(
      farmsProps[i].farmName,
      "text/html"
    );
    farm_list.push(
      <option key={i} value={farmNameDoc.body.innerText}>
        {farmNameDoc.body.innerText}
      </option>
    );
  }
  for (i = 0; i < businessProps.length; i++) {
    const businessNameDoc = parser.parseFromString(
      businessProps[i],
      "text/html"
    );
    business_list.push(
      <option key={i} value={businessNameDoc.body.innerText}>
        {businessNameDoc.body.innerText}
      </option>
    );
  }
  let sharedHistory = [];
  if (props.sharedField) {
    sharedHistory = props.userSharedFields.filter((field) => {
      return field.user_field_id === props.fieldId;
    });
  }
  return (
    <Modal
      show
      className="field-details"
      onHide={closeFieldModal}
      backdrop={false}
    >
      <Modal.Header>
        <Modal.Title>
          {"Field Details: " + fieldName}
          <OverlayTrigger
            trigger="click"
            rootClose
            placement="bottom"
            overlay={
              <Popover id="info-popover">
                <Popover.Body>
                  <p>
                    <b>IRRIG_UNIT_ID: </b>
                    {props.irrig_unit_Id}
                  </p>
                </Popover.Body>
              </Popover>
            }
          >
            <Button
              variant="secondary"
              className="small-info-button info-button fa fa-info-circle"
            ></Button>
          </OverlayTrigger>
        </Modal.Title>
        <CloseButton
          className="close field-details-close"
          onClick={(event) => closeModal(event)}
        />
      </Modal.Header>
      <Modal.Body>
        <LoadingOverlay
          showSpinner={true}
          active={false}
          text="Please wait..."
        />
        <Tabs
          defaultActiveKey={props.defaultModalActiveKey}
          transition={false}
          id="fieldDetailsTab"
        >
          <Tab eventKey="fieldDetails" title="Edit Field Details">
            <div
              id="edit_field"
              className={display_form === SHOW_FIELD ? EMPTY : "hide-form"}
            >
              <Popover.Body>
                {fieldError ? (
                  <Alert
                    key="messageAlert"
                    variant={fieldVariant}
                    closeAlert={(e) => closeFieldDetailsAlert(e)}
                    alertMessage={fieldAlertMessage}
                    dismissible
                  />
                ) : (
                  EMPTY
                )}

                <Form
                  key="popoverForm"
                  noValidate
                  validated={validated}
                  onSubmit={(e) => {
                    e.persist();
                    handleOnsubmit(e);
                  }}
                >
                  <div className="well-data">
                    <Row className="field-details-row">
                      <Form.Group as={Col} controlId="validationFieldName">
                        <Form.Label>
                          Field Name<span>*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          maxLength="40"
                          name="fieldName"
                          value={fieldName}
                          onChange={onChange}
                          required
                          className={
                            fieldNameError ? "is-invalid invalidcontrol" : EMPTY
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {fieldName === EMPTY
                            ? "Please enter field name"
                            : "Name already exists"}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        controlId="validationFarmName"
                        className="p-0"
                      >
                        <Form.Label>
                          Farm Name<span>*</span>
                        </Form.Label>
                        <Form.Select
                          required
                          onChange={handle_farm_change}
                          value={farmName}
                        >
                          <option value={EMPTY} />
                          {farm_list}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {SELECT_FARM}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Col className="col-1 ps-1">
                        <i
                          className="fa fa-plus-circle add-farm-business-wdp-btn"
                          onClick={add_new_farm}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <h4 className="mt-2 col well-label" xs={8}>
                        Well(s)
                        <OverlayTrigger
                          trigger="click"
                          rootClose
                          placement="bottom"
                          overlay={
                            <Popover id="info-popover">
                              <Popover.Body>
                                <p>
                                  <b>Active Button:</b> For any wells listed
                                  that are not utilized to irrigate the Field,
                                  please de-select the “Active” button.
                                </p>
                                <p>
                                  <b>Electric Button:</b> For any wells listed
                                  that are not powered by electricity (electric
                                  smart meter), please de-select the “Smart
                                  Meter” button.
                                </p>
                                <p>
                                  <b>GPM:</b> For all active wells, please note
                                  the pump rate listed in the “Listed GPM” box.
                                  If the “Listed GPM” is inaccurate, please
                                  update the correct pump rate in the “Updated
                                  GPM” box.
                                </p>
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <Button
                            variant="secondary"
                            className="info-button fa fa-info-circle"
                          ></Button>
                        </OverlayTrigger>
                      </h4>
                      <div className="field-acres col" xs={4}>
                        <b>Certified Acres</b>: {acres}
                      </div>
                    </Row>
                    <p className="well-info">
                      The Well(s) numbered below correspond to the location of
                      the same number on the map.
                    </p>
                    <Table className="table-responsive well-info mt-2">
                      <thead>
                        <tr>
                          <th width="10%" />
                          <th width="10%">Active</th>
                          <th width="10%">Electric </th>
                          <th width="20%">Listed GPM</th>
                          <th width="20%">Audited GPM</th>
                          <th width="20%">Updated GPM</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* for showing well details in panel */}
                        {isWellShown &&
                          well_details.map((well, index) => {
                            return (
                              <FieldWellDetails
                                well={well}
                                index={index}
                                key={index}
                                sharedField={props.sharedField}
                                updateWellDetails={updateWellDetails}
                              />
                            );
                          })}
                      </tbody>
                    </Table>
                    <h4 className="mt-4 well-label">
                      Surface Water Irrigation
                    </h4>
                    <Form.Check
                      className="popover-label"
                      checked={surfaceWaterIrrigation}
                      onChange={(e) => onCheckboxChecked()}
                      label="If the selected Field utilizes Surface Water Irrigation, please check the box and indicate the approximate irrigation from Surface Water and Ground Water (as a percentage)."
                      id="watersurface"
                      disabled={props.sharedField ? true : false}
                    />
                    {surfaceWaterIrrigation && (
                      <div className="surface-water">
                        <p className="mt-2">
                          Enter the percentage of surface water irrigation on
                          this field
                        </p>
                        <Row>
                          <Form.Group
                            as={Col}
                            md="3"
                            controlId="validationsurfaceper"
                          >
                            <Form.Label>Surface Water %</Form.Label>
                            <Form.Control
                              type="text"
                              style={{ width: "80px" }}
                              onChange={surfaceWaterChange}
                              name="surfaceWaterPercentage"
                              value={surfaceWaterPercentage}
                              maxLength="3"
                              pattern="[\d]{1,3}"
                              required
                              disabled={props.sharedField ? true : false}
                              className="w-100"
                            />
                            <Form.Control.Feedback type="invalid">
                              {surfaceWaterPercentage === EMPTY
                                ? ENTER_VALUE
                                : INVALID_VALUE}
                            </Form.Control.Feedback>
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md="3"
                            controlId="validationgroundper"
                          >
                            <Form.Label>Ground Water %</Form.Label>
                            <Form.Control
                              type="text"
                              onChange={groundWaterChange}
                              style={{ width: "80px" }}
                              name="groundWaterPercentage"
                              value={groundWaterPercentage}
                              maxLength="3"
                              pattern="[\d]{1,3}"
                              required
                              disabled={props.sharedField ? true : false}
                              className="w-100"
                            />
                            <Form.Control.Feedback type="invalid">
                              {groundWaterPercentage === EMPTY
                                ? ENTER_VALUE
                                : INVALID_VALUE}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Row>
                      </div>
                    )}
                  </div>
                  {props.sharedField ? (
                    <Button
                      className="mt-30"
                      onClick={(e) => handleSharedFieldUpdate(e)}
                      disabled={btnAddFieldClick ? true : false}
                    >
                      {btnAddFieldClick === true ? (
                        <div>
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />{" "}
                          <span>{"Updating..."}</span>
                        </div>
                      ) : (
                        "Update"
                      )}
                    </Button>
                  ) : (
                    <Button
                      className="mt-30"
                      type="submit"
                      disabled={btnAddFieldClick ? true : false}
                    >
                      {btnAddFieldClick === true ? (
                        <div>
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />{" "}
                          <span>{"Updating..."}</span>
                        </div>
                      ) : (
                        "Update"
                      )}
                    </Button>
                  )}
                </Form>
              </Popover.Body>
            </div>
            <div
              id="e_add_farm"
              className={display_form === SHOW_FARM ? EMPTY : "hide-form"}
            >
              <Popover.Header className="d-flex justify-content-between align-items-center ps-2 pe-2">
                Add Farm
                <button
                  type="button"
                  className="field-close"
                  onClick={(event) => hideShowPopup(event)}
                >
                  <i className="fa fa-long-arrow-left " aria-hidden="true"></i>
                </button>
              </Popover.Header>
              <Popover.Body>
                {farmError ? (
                  <Alert
                    key="messageAlert"
                    variant={fieldVariant}
                    closeAlert={(e) => closeFieldDetailsAlert(e)}
                    alertMessage={fieldAlertMessage}
                    dismissible
                  />
                ) : (
                  EMPTY
                )}
                <Form
                  key="popoverForm"
                  noValidate
                  validated={farmValidated}
                  onSubmit={(e) => handle_add_farm(e)}
                >
                  <Row className="field-details-row mt-2">
                    <Form.Group as={Col} controlId="validationMasterFarmName">
                      <Form.Label>
                        Farm Name<span>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        maxLength="40"
                        name="newFarmName"
                        required
                        value={newFarmName}
                        onChange={onChange}
                        className={
                          invalidFarmNameError
                            ? "is-invalid invalidcontrol"
                            : EMPTY
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {newFarmName === EMPTY
                          ? ENTER_FARM_NAME
                          : FARM_NAME_EXIST}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      controlId="validationBusinessName"
                      className="p-0"
                    >
                      <Form.Label>
                        Business Name<span>*</span>
                      </Form.Label>
                      <Form.Select
                        required
                        onChange={handle_business_change}
                        value={businessName}
                      >
                        <option value={EMPTY} />
                        {business_list}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {SELECT_BUSINESS}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Col className="col-1 ps-1">
                      <i
                        className="fa fa-plus-circle add-farm-business-wdp-btn"
                        onClick={add_new_business}
                      />
                    </Col>
                  </Row>
                  <Button
                    type="submit"
                    className="mt-2"
                    disabled={btnAddFarmClick}
                  >
                    {btnAddFarmClick ? (
                      <div>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />{" "}
                        <span>Adding...</span>
                      </div>
                    ) : (
                      "Add"
                    )}
                  </Button>
                </Form>
              </Popover.Body>
            </div>
            <div
              id="e_add_business"
              className={display_form === SHOW_BUSINESS ? EMPTY : "hide-form"}
            >
              <Popover.Header className="d-flex justify-content-between align-items-center ps-2 pe-2">
                Add Business
                <button
                  type="button"
                  className="field-close"
                  onClick={(event) => hideShowPopup(event)}
                >
                  <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                </button>
              </Popover.Header>

              <Popover.Body>
                {businessError ? (
                  <Alert
                    key="messageAlert"
                    variant={fieldVariant}
                    closeAlert={(e) => closeFieldDetailsAlert(e)}
                    alertMessage={fieldAlertMessage}
                    dismissible
                  />
                ) : (
                  EMPTY
                )}
                <Form
                  key="popoverForm"
                  noValidate
                  validated={businessValidated}
                  onSubmit={(e) => handle_add_business(e)}
                >
                  <Row className="mt-2">
                    <Form.Group
                      as={Col}
                      md="6"
                      controlId="validationMasterBusinessName"
                    >
                      <Form.Label>
                        Business Name<span>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="newBusinessName"
                        maxLength="40"
                        required
                        value={newBusinessName}
                        onChange={onChange}
                        className={
                          invalidBusinessNameError
                            ? "is-invalid invalidcontrol"
                            : EMPTY
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {newFarmName === EMPTY
                          ? ENTER_BUSINESS_NAME
                          : BUSINESS_NAME_EXIST}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6" className="mt-3">
                      <Button
                        type="submit"
                        className="mt-2"
                        disabled={btnAddBusinessClick}
                      >
                        {btnAddBusinessClick ? (
                          <div>
                            <Spinner
                              as="span"
                              animation="grow"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />{" "}
                            <span>Adding...</span>
                          </div>
                        ) : (
                          "Add"
                        )}
                      </Button>
                    </Form.Group>
                  </Row>
                </Form>
              </Popover.Body>
            </div>
          </Tab>
          <Tab eventKey="crop" title="Crop">
            <div className="cropDetails">
              {dataFetched ? (
                <TabCropDetails
                  crops={props.cropDetails}
                  SharedField={props.sharedField}
                  sharedFieldInfo={props.shareFieldDetails}
                  yearAcresDetails={props.yearAcresDetails}
                  sharedFieldDetails={sharedHistory}
                  acres={props.acres}
                  refreshPanel={(closePopup) => props.refreshPanel(closePopup)}
                  fieldId={props.fieldId}
                  irrig_unit_Id={props.irrig_unit_Id}
                  closeModal={() => props.closeModal()}
                ></TabCropDetails>
              ) : (
                EMPTY
              )}
            </div>
          </Tab>
          <Tab eventKey="fieldShare" title="FieldShare">
            <div className="fieldShare">
              <TabSharedFieldDetails
                handleCloseModel={(e) => closeModal(e)}
                sharedField={props.shareFieldDetails}
                fieldIrrigUnitId={props.irrig_unit_Id}
                fieldName={fieldName}
                fieldId={props.fieldId}
                fieldAcres={acres}
              ></TabSharedFieldDetails>
            </div>
          </Tab>
          <Tab eventKey="summary" title="Summary">
            <TabSummary fieldDetails={props.fieldDetails}></TabSummary>
          </Tab>
          <Tab eventKey="report" title="Report">
            <TabReport
              handleCloseModel={(e) => closeModal(e)}
              fieldDetails={props.fieldDetails}
            ></TabReport>
          </Tab>
          {DisplayNotesTab()}
        </Tabs>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
}

export default FarmerFieldDetails;
